export function initShowMore() {
  document.querySelectorAll('.js-show-more').forEach(showMoreEl => {
    const btnEl = showMoreEl.querySelector('.js-show-more-button')
    const textEl = showMoreEl.querySelector('.js-show-more-text')

    btnEl.addEventListener('click', () => {
      btnEl.classList.toggle('active')
      textEl.classList.toggle('active')
    })
  })
}